import { render, staticRenderFns } from "./burnup_chart.vue.js?vue&type=template&id=fa009e1e&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./burnup_chart.vue?vue&type=template&id=fa009e1e&vue3"
import script from "./burnup_chart.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./burnup_chart.vue?vue&type=script&lang=js&vue3"
export * from "./burnup_chart.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./burnup_chart.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports